<template lang="pug">
.image-selector
  v-list(two-line dense v-if='list')
    draggable(v-model='list' handle='.handle')
      v-list-tile(avatar v-for='(i, index) in list' :key='index')
        v-list-tile-action(:style='isMobile && `min-width: 30px`' @click.stop)
          v-icon.handle(color='grey' @drag.prevent.stop) dehaze
        v-list-tile-avatar(tile)
          img.pointer(:src='i' @click='showModal(i)' :title='$t("viewImage")')
        v-list-tile-content
          v-list-tile-title {{ $t('image') }} {{ index + 1 }}
          v-list-tile-sub-title {{ i }}
        v-list-tile-action
          v-btn.my-0(icon small :href='i' :title='$t("downloadImage")' @click.stop download target='_blank')
            v-icon(small) save_alt
        v-list-tile-action
            v-btn.my-0.error--text(icon small @click.stop='remove(index)' :title='$t("remove")')
              v-icon close

  .dropbox(ref='dropbox' :class='{ drag: isDragging }' v-show='isDropboxShow')
    v-btn.mt-2.upload-button(block large @click='clickUpload')
      v-icon(left small) fas fa-upload
      | {{ $t('selectOrDrag') }}
    input(ref='hiddenFileInput' type='file' multiple accept='image/*' @change='change')

  v-dialog(v-model='isDialogShow' max-width='600')
    v-card
      img(:src='dialogImage' v-if='dialogImage')
</template>

<script>
import lrz from 'lrz'
import Loader from '@/components/Loader.vue'
import UploadButton from 'vuetify-upload-button'
import draggable from 'vuedraggable'

export default {
  name: 'ImageSelectorMultiple',
  data () {
    this.lazySrc = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM8UQ8AAhUBSQV8WJQAAAAASUVORK5CYII='
    return {
      list: [],
      isDragging: false,
      isDialogShow: false,
      dialogImage: null,
    }
  },
  props: {
    value: { },
    max: {
      type: Number,
      default: 800,
    },
    maxFileCount: {
      type: Number,
      default: 5,
    },
  },
  mounted () {
    const dropbox = this.$refs.dropbox

    dropbox.addEventListener('dragenter', this.onDrag, false)
    dropbox.addEventListener('dragover', this.onDrag, false)
    dropbox.addEventListener('drop', this.onDrop, false)
    dropbox.addEventListener('dragleave', this.onLeave, false)
  },
  methods: {
    // 按下上傳按鈕
    clickUpload () {
      this.$refs.hiddenFileInput.click()
    },
    change (e) {
      this.handleFiles(e.target.files)
    },
    // 選擇新的圖片檔案
    add (file) {
      lrz(file, { width: this.max, height: this.max })
        .then(result => {
          const sizeKb = result.file.size / 1000
          if (sizeKb < 1000) {
            if (!this.list) this.list = []
            this.list.push(result.base64)
          } else {
            alert('The compressed image is still too big!')
          }
        })
        .catch(e => alert('圖片讀取失敗! 請嘗試其他檔案'))
    },
    onDrag (e) {
      e.stopPropagation()
      e.preventDefault()
      this.isDragging = true
    },
    onDrop (e) {
      e.stopPropagation()
      e.preventDefault()
      const files = e.dataTransfer.files
      this.handleFiles(files)

      this.isDragging = false
    },
    onLeave (e) {
      this.isDragging = false
    },
    remove (index) {
      this.list.splice(index, 1)
    },
    showModal (_) {
      this.dialogImage = _
      this.isDialogShow = true
    },
    handleFiles (files) {
      if (files && files.length > 0) {
        const currentCount = Array.isArray(this.list) ? this.list.length : 0

        if (files.length + currentCount > this.maxFileCount) {
          alert(this.$t('overMaximumFail', { n: this.maxFileCount }))
        } else {
          Array.from(files).forEach(_ => this.add(_))
        }
      }
    },
  },
  computed: {
    isDropboxShow () {
      return !this.list || (Array.isArray(this.list) && this.list.length < this.maxFileCount)
    },
  },
  watch: {
    value: {
      handler (_) {
        if (typeof _ === 'string') {
          this.list = [_]
          this.$emit('input', this.list)
        } else {
          this.list = _
        }
      },
      immediate: true,
    },
    list: {
      handler (_) {
        this.$emit('input', _)
      },
      deep: true,
    },
  },
  components: {
    Loader,
    UploadButton,
    draggable,
  },

}
</script>

<style scoped lang='sass'>
.upload-button
  min-height: 5rem

.dropbox
  transition: opacity .2s
  &.drag
    position: relative
    opacity: .5

input[type='file']
  display: none

img
  width: 100%
  height: auto
  object-fit: contain
</style>

<i18n src="@/lang/components/imageSelectorMultiple.json"></i18n>
